import { useCallback, useEffect, useState } from 'react';
export const useTwoStepFlow = _ref => {
  let enabled = _ref.enabled,
    queryFromUrl = _ref.queryFromUrl;
  const _useState = useState('names'),
    mobileStep = _useState[0],
    setMobileStep = _useState[1];
  // Toggled on back navigation to re-trigger the names step slide-in.
  const _useState2 = useState(false),
    namesEntering = _useState2[0],
    setNamesEntering = _useState2[1];
  // Clips horizontal overflow only while a step slide-in plays (see .bngSwipeClip).
  const _useState3 = useState(false),
    stepAnimating = _useState3[0],
    setStepAnimating = _useState3[1];
  const resetToNames = useCallback(() => setMobileStep('names'), []);
  useEffect(() => {
    if (enabled) {
      resetToNames();
    }
  }, [queryFromUrl, enabled, resetToNames]);
  useEffect(() => {
    if (!stepAnimating) {
      return;
    }
    // Release just after the 0.28s slide-in finishes.
    const timeoutId = window.setTimeout(() => setStepAnimating(false), 320);
    return () => window.clearTimeout(timeoutId);
  }, [stepAnimating]);
  const goToDomains = useCallback(() => {
    setNamesEntering(false);
    setStepAnimating(true);
    setMobileStep('domains');
    window.scrollTo({
      top: 0
    });
  }, []);
  const goBackToNames = useCallback(() => {
    setNamesEntering(true);
    setStepAnimating(true);
    setMobileStep('names');
  }, []);
  return {
    mobileStep,
    namesEntering,
    stepAnimating,
    isNamesStepVisible: !enabled || mobileStep === 'names',
    isDomainsStepVisible: !enabled || mobileStep === 'domains',
    resetToNames,
    goToDomains,
    goBackToNames
  };
};
//# sourceMappingURL=useTwoStepFlow.js.map